import labels from './metricsLabels'
import rowTypeMap from './rowTypeMap'

export default {
    labels,
    rowTypeMap
}


// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/components/scorecard/MetricsLabels/index.js